import toggleBackdrop from "../../utils/toggleBackdrop";
import {clearModalContent, renderInModal} from "../../utils/renderModal";

document.addEventListener('DOMContentLoaded', () => {
  const btnEl = document.querySelector('button.a-box-menu__item-play');
  const modal = document.getElementById("a-modal");
  const backdropEl = document.querySelector(".a-backdrop");
  const modalCloseBtnEl = modal.querySelector(".close");
  const contentEl = document.querySelector('.a-box-menu__item-play__content');

  if (!btnEl) return;

  const onClose = () => {
    backdropEl.classList.remove('active');
    modal.style.display = "none";
    clearModalContent();
  }

  btnEl.addEventListener('click', () => {
    toggleBackdrop();
    const nonLoadableContent = contentEl.innerHTML.replace('data-src', 'src');
    renderInModal(nonLoadableContent);

    modal.style.display = "block";
    modalCloseBtnEl.addEventListener('click', () => {
      onClose();
    })

    backdropEl.addEventListener('click', (event) => {
      onClose();
    })
  });
});
